// StudentUserProfile.js
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { UserContext } from "../context/UserContext";
import { useNavigate } from "react-router-dom";
import "../styles/StudentUserProfile.css";
import Footer from "../Footer";

const StudentUserProfile = () => {
  const { user, logoutUser } = useContext(UserContext);
  const navigate = useNavigate();

  const [studentData, setStudentData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [updatedData, setUpdatedData] = useState({
    name: "",
    phone_number: "",
    whatsapp_number: "",
  });

  // Logout function
  const handleLogout = async () => {
    try {
      logoutUser();
      navigate("/login");

      console.log("User logged out successfully!");
    } catch (error) {
      console.error("Error logging out:", error.message);
    }
  };

  //  Redirect if not student
  useEffect(() => {
    if (!user || user.role !== "student") {
      navigate("/login");
    }
  }, [user, navigate]);

  //  Fetch student data
  useEffect(() => {
    const fetchStudentData = async () => {
      if (!user?.token) return;
      try {
        const response = await axios.get(
          "https://tn.server.goatteachers.com/api/students/me",
          { headers: { Authorization: `Bearer ${user.token}` } },
        );
        setStudentData(response.data);
        setUpdatedData({
          name: response.data.name,
          phone_number: response.data.phone_number || "",
          whatsapp_number: response.data.whatsapp_number || "",
        });
      } catch (error) {
        console.error("Error fetching student data:", error);
        if (error.response?.status === 401) {
          alert("Session expired. Please log in again.");
          logoutUser();
          navigate("/login");
        }
      }
    };
    fetchStudentData();
  }, [user, navigate, logoutUser]);

  //  Handle form changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedData((prev) => ({ ...prev, [name]: value }));
  };

  //  Save changes
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        "https://tn.server.goatteachers.com/api/students/update",
        updatedData,
        { headers: { Authorization: `Bearer ${user.token}` } },
      );
      setStudentData(response.data);
      setIsEditing(false);
      alert("Profile updated successfully!");
    } catch (error) {
      console.error("Error updating student data:", error);
    }
  };

  //  Delete account
  const handleDelete = async () => {
    if (!window.confirm("Delete your account permanently?")) return;
    try {
      await axios.delete(
        "https://tn.server.goatteachers.com/api/students/delete",
        {
          headers: { Authorization: `Bearer ${user.token}` },
        },
      );
      alert("Account deleted.");
      logoutUser();
      navigate("/");
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  if (!studentData) return <div className="loading">Loading profile...</div>;

  return (
    <>
      <div className="profile-wrapper">
        {/* Header */}
        <div className="profile-header">
          <img
            className="profile-avatar"
            src={`https://ui-avatars.com/api/?name=${
              studentData?.name || "Student"
            }&background=random`}
            alt="Student Avatar"
          />
          <h2 className="profile-name">{studentData.name}</h2>
          <p className="profile-email">{studentData.email}</p>
        </div>

        {/* Stats */}
        <div className="profile-stats">
          <div className="stat-card">
            <h3>{studentData.connections || 0}</h3>
            <p>Connections Made</p>
          </div>
        </div>

        {/* Info */}
        <div className="profile-info">
          <p>
            <strong>Phone:</strong> {studentData.phone_number || "Not Provided"}
          </p>
          <p>
            <strong>WhatsApp:</strong>{" "}
            {studentData.whatsapp_number || "Not Provided"}
          </p>
        </div>

        {/* Edit Form */}
        {isEditing && (
          <form onSubmit={handleSubmit} className="edit-form">
            <div>
              <label>Name</label>
              <input
                type="text"
                name="name"
                value={updatedData.name}
                onChange={handleChange}
              />
            </div>
            <div>
              <label>Phone Number</label>
              <input
                type="text"
                name="phone_number"
                value={updatedData.phone_number}
                onChange={handleChange}
              />
            </div>
            <div>
              <label>WhatsApp Number</label>
              <input
                type="text"
                name="whatsapp_number"
                value={updatedData.whatsapp_number}
                onChange={handleChange}
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="update-button">
                Save Changes
              </button>
            </div>
          </form>
        )}

        {/* Actions */}
        <div className="profile-actions">
          <button
            className="update-button"
            onClick={() => setIsEditing(!isEditing)}
          >
            {isEditing ? "Cancel" : "আপডেট একাউন্ট"}
          </button>
          <button className="delete-button" onClick={handleDelete}>
            ডিলিট একাউন্ট
          </button>
          {user && (
            <a
              className="logoutBtn"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleLogout();
              }}
            >
              লগ আউট
            </a>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default StudentUserProfile;
